import dayjs from 'dayjs';

export function getLastWeekdayOfMonth(year: number, month: number, weekday: number) {
  // Start at the last day of the month
  const endOfMonth = dayjs().year(year).month(month).endOf('month');

  // `endOfMonth.day()` gives the weekday of the last day of the month
  // weekday: 0=Sunday, 1=Monday, ..., 6=Saturday
  let offset = endOfMonth.day() - weekday;

  if (offset < 0) {
    // If offset is negative, we need to wrap back by a week
    offset += 7;
  }

  // Subtracting offset days from the last day of the month
  const lastOccurrence = endOfMonth.subtract(offset, 'day');
  return lastOccurrence.toDate();
}
